module.exports = __webpack_public_path__ + "img/grand-cancun-hotel-3.a84b6950.jpg";